import React, { useRef } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Loader() {
  return (
    <div className="grid min-h-screen place-items-center bg-gray-50">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-[#720e1e]" />
    </div>
  );
}

export default function FinanceRoute({ children }) {
  const {
    user,
    isAuthenticated,
    loading,
    authReady,
    adminAccessLoading,
    adminAccess,
  } = useAuth();
  const hasGrantedAccessRef = useRef(false);

  const roles = (adminAccess?.roles || []).map((role) =>
    String(role).trim().toLowerCase(),
  );
  const allowed = roles.some((role) =>
    ["finance", "admin", "superadmin"].includes(role),
  );

  if (user && allowed) {
    hasGrantedAccessRef.current = true;
  }

  const accessCheckPending = loading || !authReady || adminAccessLoading;

  if (accessCheckPending) {
    return hasGrantedAccessRef.current ? children : <Loader />;
  }

  if (!isAuthenticated || !user) {
    hasGrantedAccessRef.current = false;
    return <Navigate to="/login" replace />;
  }

  if (allowed) {
    hasGrantedAccessRef.current = true;
    return children;
  }

  if (hasGrantedAccessRef.current && adminAccess == null) {
    return children;
  }

  hasGrantedAccessRef.current = false;
  return <Navigate to="/dashboard" replace />;
}
